import { createBrowserRouter } from 'react-router-dom';
import { Layout } from '@/components/Layout';
import { ProtectedRoute } from '@/components';
import Home from '@/pages/Home';
import Signin from '@/pages/SignIn';
import Signup from '@/pages/SignUp';
import ServiceCenter from '@/pages/ServiceCenter';
import SagawaExp from '@/pages/SagawaExp';
import LuggagePrecautionsPage from '@/pages/SagawaExp/LuggagePrecautionsPage';
import LuggageFaqPage from '@/pages/SagawaExp/LuggageFaqPage';
import HanedaShop from '@/pages/HanedaShop';
import Vip from '@/pages/Vip';
import AITrip from '@/pages/AITrip';
import DestinationEmbed from '@/pages/DestinationEmbed';
import ManusThemeEmbed from '@/pages/ManusThemeEmbed';
import { MANUS_THEME_SLUGS } from '@/constants/manusThemeEmbed';
import Orders from '@/pages/Orders';
import CarRental from '@/pages/CarRental';
import CarRentalReserve from '@/pages/CarRental/Reserve';
import Coupon from '@/pages/Coupon/Index';
import Profile from '@/pages/Profile';
import CouponList from '@/pages/Coupon/List';
import Protocol from '@/pages/Protocol';
import MineCoupon from '@/pages/Coupon/Mine';
import TermsOfService from '@/pages/TermsOfService';
import PrivacyPolicy from '@/pages/PrivacyPolicy';
import Items from '@/pages/Items';
import CouponPrecautions from '@/pages/Coupon/CouponPrecautions';
import TempCouponList from '@/pages/Coupon/Temp/List';
import TempCouponDetail from '@/pages/Coupon/Temp/Detail';


const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: '/service-center',
        element: <ServiceCenter />,
      },
      {
        path: '/airport-luggage-delivery',
        element: <SagawaExp />,
      },
      {
        path: '/airport-luggage-precautions',
        element: <LuggagePrecautionsPage />,
      },
      {
        path: '/airport-luggage-faq',
        element: <LuggageFaqPage />,
      },
      {
        path: '/duty-free-pre-order',
        element: <HanedaShop />,
      },
      {
        path: '/vip',
        element: <Vip />,
      },
      {
        path: '/ai-trip',
        element: <AITrip />,
      },
      {
        path: '/destination/:slug',
        element: <DestinationEmbed />,
      },
      ...MANUS_THEME_SLUGS.map((slug) => ({
        path: `/${slug}`,
        element: <ManusThemeEmbed />,
      })),
      {
        path: '/car-rental',
        element: <CarRental />,
      },
      {
        path: '/car-rental/reserve',
        element: (
          <ProtectedRoute>
            <CarRentalReserve />
          </ProtectedRoute>
        ),
      },
      // {
      //   path: '/coupon',
      //   element: <Coupon />,
      // },
      {
        path: '/coupon-list',
        element: (
          <CouponList />
        ),
      },
      // 优惠券临时的静态页面
      {
        path: '/temp-coupon-list',
        element: <TempCouponList />,
      },
      {
        path: '/temp-coupon-detail',
        element: <TempCouponDetail />,
      },
      {
        path: '/mine-coupon',
        element: (
          <ProtectedRoute>
            <MineCoupon />
          </ProtectedRoute>
        ),
      },
      {
        path: '/orders',
        element: (
          <ProtectedRoute>
            <Orders />
          </ProtectedRoute>
        ),
      },
      {
        path: '/profile',
        element: (
          <ProtectedRoute>
            <Profile />
          </ProtectedRoute>
        ),
      },
      {
        path: '/terms',
        element: <TermsOfService />,
      },
      {
        path: '/privacy',
        element: <PrivacyPolicy />,
      },
      {
        path: '/items',
        element: <Items />,
      },
      {
        path: '/coupon-precautions',
        element: <CouponPrecautions />,
      },
    ],
  },
  {
    path: '/signin',
    element: <Signin />,
  },
  {
    path: '/signup',
    element: <Signup />,
  },
  {
    path: '/protocol',
    element: <Protocol />,
  },
]); 

export default router;